import Store from 'store/store';

function isFullDate(dateStr) {
	return dateStr?.split('-')?.length === 3 || false;
}

export function getDefaultButtons(movie, status = movie?.status, copy = Store.get().appData?.copy?.baseCopy) {
	const getTicketsButton = { enabled: true, label: copy?.$BUTTON_SHOWTIMES || copy?.$GET_TICKETS || 'Get tickets', path: 'boltShowtimes', order: 0 };
	const watchAtHomeButton = { enabled: true, label: copy?.$BUTTON_HOMEENT || copy?.$WATCH_AT_HOME || 'Watch At Home', path: 'boltHomeEnt', order: 1 };
	const saveToCalendarButton = { enabled: true, label: copy?.$CALENDAR_REMINDER_BTN_COPY || 'Save To Calendar', path: '@calendarreminder', order: 2 };
	const watchTrailerButton = { enabled: true, label: copy?.$BUTTON_TRAILER || copy?.$WATCH_TRAILER || 'Watch Trailer', path: 'boltVideos', order: 3 };

	const areTicketsOnSale = movie?.pages?.showtimes?.active && (status?.theaters === 'inTheaters' || status?.theaters === 'preSale');
	const isHomeEntAvailable = movie?.pages?.homeEnt?.active && status?.homeEnt === 'homeEnt';
	const inComingSoon = status?.theaters === 'comingSoon' && !(areTicketsOnSale || isHomeEntAvailable) && isFullDate(movie?.dates?.release);
	const hasVideos = Object.values(movie?.trailers || {}).some(Boolean);

	const buttons = [
		areTicketsOnSale && getTicketsButton,
		isHomeEntAvailable && watchAtHomeButton,
		inComingSoon && saveToCalendarButton,
		hasVideos && watchTrailerButton,
	].filter(Boolean);

	return {
		button1: buttons[0] || { enabled: false },
		button2: buttons[1] || { enabled: false },
	};
}